import {Select, Stack,} from '@mui/material';
import useStyles from './useStyles';
import MenuItem from "@mui/material/MenuItem";
import {memo} from "react";

/*
* @props = {
*   onSelectChange: () => {},
*   optionList: MenuItem[]
* }
*
* MenuItem @props = {
*   id: number,
*   link: string,
*   text: string,
*   disabled?:boolean,
*   show?: boolean
* }
* */
export const StylizedMenuList = memo((props) => {

    const classes = useStyles()
    const {onSelectChange, optionList, className} = props

    const handleChange = (e) => {
        onSelectChange?.(e)
    }

    return (
        <Stack direction="row" spacing={1} className={`${classes.detalizationListStack} ${className || ''}`}>
            <Select
                labelId="detalization-list"
                value={optionList[0]?.id}
                label="detalization-list"
                onChange={handleChange}
                variant="standard"
                className={classes.selectComponent}
            >
                {optionList.map(value => (
                    <MenuItem
                        key={value.id}
                        value={value.id}
                        className={`${classes.menuItem} ${value.show === false ? 'hide' : ''}`}
                        disabled={value.disabled}
                    >{value.text}</MenuItem>
                ))}
            </Select>
        </Stack>
    );
})